import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import { getPaginationActions } from '~/shared/helpers/redux-helpers';
import { pagesInitialState } from '~/shared/store/slices/course-categories/course-categories-slice';

type LessonTemplatesType = {
  messagesPagination: {
    isLoading: boolean;
    items: [];
    pageInfo: {
      hasPreviousPage: boolean;
      hasNextPage: boolean;
      currentPage: number;
      perPage: number;
      itemCount: number;
      pageCount: number;
    };
  };
};

const initialState: LessonTemplatesType = {
  messagesPagination: {
    isLoading: false,
    items: [],
    pageInfo: pagesInitialState,
  },
};

export const messagesSlice = createSlice({
  name: 'messages',
  initialState,
  reducers: {
    setMessagesPagination: (state, action: PayloadAction<[]>) => {
      state.messagesPagination = action.payload;
    },
    ...getPaginationActions('messagesPagination'),
  },
});

export const { setMessagesPagination, setMessagesPaginationLoading, appendMessagesPagination } = messagesSlice.actions;
